import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import {
  borderWidth,
  borderStyle,
  borderRadius as radius,
} from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { KG_DATA_STORY_NODE_WIDTH_PX } from "../../kg/kgNodeDimensions";
import { kgSelectionGlowShadow } from "../../kg/kgLineageTokens";
import { kgNodeEllipsisTextCenterStyles } from "../../kg/kgNodeText.styles";
import type { KgNodeVisualState } from "../../kg/kgNodeShared.types";

export const Card = styled.div<{
  $visualState: KgNodeVisualState;
  $isSelected: boolean;
}>`
  width: ${KG_DATA_STORY_NODE_WIDTH_PX}px;
  max-width: ${KG_DATA_STORY_NODE_WIDTH_PX}px;
  border-radius: 16px;
  overflow: hidden;
  border: ${borderWidth[1]} ${({ $visualState }) =>
    $visualState === "draft" ? borderStyle.dashed : borderStyle.solid}
    ${rawColors.accent.dataStoryPurple};
  background: ${rawColors.structural.white};
  box-shadow: ${({ $isSelected }) =>
    kgSelectionGlowShadow(rawColors.accent.dataStoryPurpleBg, $isSelected)};
  outline: none;
  transition: box-shadow 0.25s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing[3]};
  padding: ${spacing[4]};
  cursor: pointer;
`;

export const IconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: ${radius.lg};
  background: ${rawColors.accent.dataStoryPurpleBg};
  color: ${rawColors.accent.dataStoryPurple};
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const StoryName = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
  ${kgNodeEllipsisTextCenterStyles}
  width: 100%;
`;
